var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('no-ssr',[_c('PoiMapComponent',{attrs:{"id":"map-component","countryCode":_vm.activeLocale,"show-filters":true,"show-make-an-appointment":true,"eventBus":_vm.eventBus}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }